// Code generated by pkg/router_helper/make_api.go, DO NOT EDIT.

import { fetchApi } from '../fetchApi'

import * as Types from './type'

export const countryApi = {
  GetCountryCodeByIp: {
    method: 'post',
    path: '/api-bff/country/get-countrycode-by-ip',
    fnMeta: {
      parameters: [
        {
          kind: 'body',
        },
      ],
      returnType: {
        kind: '',
      },
    },
    flag: ['__middleware/udb_authentication__flag__'],
  },
}

export function GetCountryCodeByIp(body: Types.CountryCodeByIpRqpDTO, ...args: any): Promise<Types.CountryCodeByIpRespDTO> {
  return fetchApi(countryApi.GetCountryCodeByIp as any, body, ...args) as Promise<Types.CountryCodeByIpRespDTO>
}
